import React from 'react';
import { useId } from '@reach/auto-id';
import { BaseSelect, BaseSelectProps } from '../BaseSelect/BaseSelect';
import { Label } from '../../Label/Label';
import { HelperText } from '../../HelperText/HelperText';
import { Wrapper } from '../../Wrapper/Wrapper';
import { MarginProps } from '../../../../theme/styledProps';
import { extractMarginProps } from '../../utils/extractMarginProps';

export interface SelectProps<Option, IsMulti extends boolean>
  extends BaseSelectProps<Option, IsMulti>,
    MarginProps {
  label?: React.ReactNode;
  helperText?: string;
  disabled?: boolean;
  tooltip?: string;
  noWrap?: boolean;
}

export function Select<Option, IsMulti extends boolean = false>({
  id,
  label,
  helperText,
  formVariant,
  disabled,
  className,
  tooltip,
  ...rest
}: SelectProps<Option, IsMulti>) {
  const selectId = `select--${useId(id)}`;
  const descriptionId = `select--help-text--${useId()}`;

  return (
    <Wrapper {...extractMarginProps(rest)} className={className}>
      {label && (
        <Label htmlFor={selectId} variant={formVariant} tooltip={tooltip} mb="4">
          {label}
        </Label>
      )}

      <BaseSelect
        inputId={selectId}
        formVariant={formVariant}
        isDisabled={disabled}
        aria-describedby={helperText ? descriptionId : undefined}
        aria-invalid={formVariant === 'error'}
        {...rest}
      />

      {helperText && (
        <HelperText descriptionId={descriptionId} variant={formVariant} mt="4">
          {helperText}
        </HelperText>
      )}
    </Wrapper>
  );
}
